export const getFileName = (filePath: string) => {
  const pathParts = filePath.split('/')
  return pathParts.pop()
}

export const getFileDir = (filePath: string) => {
  const pathParts = filePath.split('/')
  return pathParts.slice(0, -1).join('/')
}

export const getResizedFilePath = (filePath: string) =>
  `${getFileDir(filePath)}/resized_${getFileName(filePath)}`
